import withDefaultLayout from "@Hocs/withDefaultLayout/withDefaultLayout";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { compose } from "redux";
import IllustrationSVG from "../../../public/images/gather.svg";
import {
    WelcomeUser,
    WelcomeBodyText,
    OverviewPageWrapper,
} from "@Styled/Pages/Overview.styled";
import { actions as dialogActions } from "@Store/Reducers/dialog";
import { ChannelActions, RootStateType } from "@Store";
import { IChannel } from "@Interfaces";
import { DialogComponents } from "@Interfaces/Entities/Dialogs";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import tblogo from "../../../public/images/tb-icon.png";
import { useTranslation } from "react-i18next";
import useIsChannelAdmin from "@Hooks/useIsChannelAdmin";

const Overview: React.FC<any> = () => {
    const { t } = useTranslation();
    const channels: Array<IChannel> = useSelector(
        (state: RootStateType) => state.channels.channels
    );
    const { resetJoinChannel } = ChannelActions;
    const navigate = useNavigate();
    const dispatch = useDispatch<any>();
    const userName = useSelector(
        (state: RootStateType) => state.auth.user.username
    );
    const invitationChannel = useSelector(
        ({ channels }: RootStateType) => channels.invitation as IChannel
    );
    const isOwner = useIsChannelAdmin(invitationChannel);
    // An owner who opened their own share link is taken straight to the event.
    // Anyone else stays a participant: the old "join this channel" prompt is retired.
    const handleInvitation = () => {
        if (!invitationChannel?._id) return;

        if (isOwner) {
            dispatch(dialogActions.hideDialog());
            navigate(`/channel/${invitationChannel._id}`);
            dispatch(resetJoinChannel());
        }
    };
    const handleOpen = () => {
        dispatch(
            dialogActions.openDialog({
                id: DialogComponents.CreateChannelDialog,
            })
        );
    };
    useEffect(() => {
        handleInvitation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invitationChannel?._id, isOwner]);
    return (
        <OverviewPageWrapper>
            <WelcomeUser className="text-start">
                <h2
                    style={{
                        color: "#606060",
                        fontWeight: "bold",
                        marginBottom: "10px",
                        textAlign: "center",
                    }}
                >
                    {t("overview.welcome_user")}{" "}
                    <b
                        style={{
                            fontWeight: "bold",
                            color: "#786bfe",
                        }}
                    >
                        {userName}
                    </b>
                    !
                </h2>
            </WelcomeUser>
            <WelcomeBodyText>
                {t("overview.welcome_body")}
                <a
                    style={{
                        marginLeft: "5px",
                        textDecoration: "none",
                        color: "#3f51b5",
                    }}
                    href="tendbe.com"
                >
                    {t("overview.welcome_here")}
                </a>
                .
                <br />
                <div
                    style={{
                        textAlign: "center",
                        marginTop: "30px",
                        marginBottom: "30px",
                    }}
                >
                    {t("overview.welcome_journey")}
                    <span role="img" aria-label="celebrate">
                        <img
                            src={tblogo}
                            alt="tendbe-logo"
                            width={30}
                            style={{ marginLeft: "10px" }}
                        />
                    </span>
                </div>
            </WelcomeBodyText>
            {!channels.length && (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpen}
                >
                    {t("overview.create_event")}
                </Button>
            )}
            <div className="responsive">
                <img
                    src={IllustrationSVG}
                    alt="tendbe-world"
                    style={{
                        maxHeight: "40vh",
                    }}
                />
            </div>
        </OverviewPageWrapper>
    );
};

export default compose(withDefaultLayout)(Overview);
